export const BANNER_WIDTH = 1200;
export const BANNER_HEIGHT = 600;
export const BANNER_RATIO = BANNER_WIDTH / BANNER_HEIGHT;
export const BANNER_MAX_BYTES = 5 * 1024 * 1024;
export const BANNER_SIZE_LABEL = `${BANNER_WIDTH} × ${BANNER_HEIGHT} px`;

export function validateBannerSource(file) {
  if (!["image/jpeg", "image/png", "image/webp"].includes(file.type))
    return "Choose a JPG, PNG or WebP image.";
  if (file.size > BANNER_MAX_BYTES) return "Choose an image up to 5 MB.";
  return "";
}
export function validateBannerDimensions({ width, height }, exact = false) {
  if (
    exact
      ? width !== BANNER_WIDTH || height !== BANNER_HEIGHT
      : width < BANNER_WIDTH || height < BANNER_HEIGHT
  ) {
    return exact
      ? `Banner images must be exactly ${BANNER_SIZE_LABEL}. Replace or crop this image before saving.`
      : `Choose an image at least ${BANNER_SIZE_LABEL} to keep the mobile banner sharp.`;
  }
  return "";
}
export function readBannerDimensions(source) {
  return new Promise((resolve, reject) => {
    const local = typeof source !== "string";
    const url = local ? URL.createObjectURL(source) : source;
    const img = new Image();
    const clean = () => {
      if (local) URL.revokeObjectURL(url);
    };
    img.onload = () => {
      clean();
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      clean();
      reject(new Error("Unable to read this image. Choose another JPG, PNG or WebP file."));
    };
    img.src = url;
  });
}
